<template>
  <Header />
  <ServiceProperty />
  <Service />
  <ServiceIcons />
  <Footer />
</template>
<script>
import Service from "@/components/Service/DataVisualization/Service.vue";
import ServiceIcons from "@/components/Service/DataVisualization/ServiceIcons.vue";
import ServiceProperty from "@/components/Service/DataVisualization/ServiceProperty.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Service,
    ServiceIcons,
    ServiceProperty,
    Header,
    Footer,
  },
};
</script>
